<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="d-flex">
  <div class="form-group w-40 me-10" [formGroup]="parentFormGroup">
    <div *ngIf="!hideLabel" class="label d-flex justify-content-between">
      <span>
        {{ 'CLIENTABLE_SELECT.CLIENTABLE_TYPE' | translate }}
      </span>
    </div>

    <ng-select
      [items]="data"
      bindLabel="key"
      bindValue="value"
      [formControlName]="'clientable_type'"
      (change)="selectClientableType()"
    >
      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        {{ 'CLIENTABLE_SELECT.' + item.key | translate }}
      </ng-template>
    </ng-select>
  </div>
  <div class="w-60">
    <app-client-select
      *ngIf="parentFormGroup.get('clientable_type').value === ClientabeType.CLIENT"
      [parentFormGroup]="parentFormGroup"
      [passFormControlName]="'clientable_id'"
      [includes]="'bank_accounts'"
    >
    </app-client-select>

    <app-hotel-select
      *ngIf="parentFormGroup.get('clientable_type').value === ClientabeType.HOTEL"
      [parentFormGroup]="parentFormGroup"
      [passFormControlName]="'clientable_id'"
      [includes]="'bank_accounts'"
    >
    </app-hotel-select>

    <app-supplier-select
      *ngIf="parentFormGroup.get('clientable_type').value === ClientabeType.SUPPLIER"
      [parentFormGroup]="parentFormGroup"
      [passFormControlName]="'clientable_id'"
      [includes]="'bank_accounts'"
    >
    </app-supplier-select>

    <app-company-select
      *ngIf="parentFormGroup.get('clientable_type').value === ClientabeType.COMPANY"
      [parentFormGroup]="parentFormGroup"
      [passFormControlName]="'clientable_id'"
      [includes]="'bank_accounts'"
    >
    </app-company-select>
  </div>
</div>
